import { render, staticRenderFns } from "./musteribilgipart.vue?vue&type=template&id=2b2cc382&"
import script from "./musteribilgipart.vue?vue&type=script&lang=js&"
export * from "./musteribilgipart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports